import type { HttpTransport } from '@mangovoice/api-client'
import type { PaginatedApiResult, Voicemail } from '@mangovoice/types'
import type { components } from '@mangovoice/types/generated/mango-api'

import { stringifyParams } from './utils'

export type VoicemailInstance = components['schemas']['Voicemail']

export interface GetVoicemailsParams {
  pbxId: number
  extensionId?: number
  search?: string
  offset?: number
  limit?: number
  unread?: 'all' | 'true' | 'false'
}

export function createVoicemailsResource(transport: HttpTransport) {
  return {
    getVoicemails: (params: GetVoicemailsParams) => {
      const qs = stringifyParams({
        ordering: '-id',
        pbx_id: params.pbxId,
        extension_id: params.extensionId,
        search: params.search,
        limit: params.limit ?? 25,
        unread: params.unread,
        offset: params.offset,
      })
      return transport.get<PaginatedApiResult<Voicemail>>(`/voicemails/?${qs}`)
    },

    getVoicemail: (voicemailId: number) =>
      transport.get<VoicemailInstance>(`/voicemails/${voicemailId}/`),

    markVoicemailRead: (voicemailId: number) =>
      transport.put<{ message: string }>(
        `/voicemails/${voicemailId}/mark-as-read/`,
      ),

    markVoicemailUnread: (voicemailId: number) =>
      transport.put<{ message: string }>(
        `/voicemails/${voicemailId}/mark-as-unread/`,
      ),

    deleteVoicemail: (voicemailId: number) =>
      transport.delete<{ message: string }>(`/voicemails/${voicemailId}/`),

    moveVoicemail: (voicemailId: number, extensionId: number) =>
      transport.put<{ message: string }>(
        `/voicemails/${voicemailId}/move-to-extension/`,
        { extension_id: extensionId },
      ),
  }
}
